// Home.tsx

import React from "react";
import home from "../../assets/images/portfolio_home.webp";

import { FaGithub, FaLinkedin } from "react-icons/fa";

import classes from "./Home.module.css";

import { useSelector } from "react-redux";

import { RootState } from "../../store/appStore";

import RoleGenerator from "../../component-lib/RoleGenerator";

import { getLinkFromLinks } from "../../utils/helperFunctions";

import { Link } from "react-router-dom";

import { motion } from "framer-motion";

const Home = () => {
	const { data } = useSelector((state: RootState) => state.data);

	const staticData = data?.home;

	const links = data?.externalLinks;

	const buttonStaticData = data?.buttons;

	const handleContact = () => {
		window.dataLayer = window.dataLayer || [];

		window.dataLayer.push({
			event: "contact_click",
			event_category: "engagement",
			event_label: "Contact Button",
		});
	};

	return (
		<div id="home" className={`${classes.homeContainer} scrollSection`}>
			<div className={classes.col1}>
				<p>{staticData?.miniTitle}</p>

				<h1 className={classes.nameTitle}>
					{staticData?.title.split(" ")[0]}

					<span> {staticData?.title.split(" ")[1]}</span>
				</h1>

				<div className={classes.roleText}>
					<RoleGenerator roles={staticData?.roles} />
				</div>

				<div className={classes.iconsContainer}>
					<a
						aria-label={`Navigate to - ${links ? links[1]?.name : "Github"}`}
						href={getLinkFromLinks(links, links ? links[1]?.name : "")}
						target="_blank"
						rel="noreferrer"
					>
						<FaGithub className={classes.icon} />
					</a>

					<a
						aria-label={`Navigate to - ${links ? links[0]?.name : "LinkedIn"}`}
						href={getLinkFromLinks(links, links ? links[0]?.name : "")}
						target="_blank"
						rel="noreferrer"
					>
						<FaLinkedin className={classes.icon} />
					</a>
				</div>

				<div className={classes.homeButtonContainer}>
					<Link role="button" id="resume" to="/resume_preview">
						{buttonStaticData?.resumeBtn}
					</Link>

					<a role="button" href="#contact" onClick={handleContact}>
						{buttonStaticData?.contactBtn}
					</a>
				</div>
			</div>

			<div className={classes.col2}>
				<motion.img
					src={home}
					alt="profile"
					animate={{
						y: [0, 12, 0],
					}}
					transition={{
						duration: 5,
						repeat: Infinity,
						ease: "easeInOut",
					}}
				/>
			</div>
		</div>
	);
};

export default Home;
